import { render, staticRenderFns } from "./ReasonAddNew.vue?vue&type=template&id=56e235a4&"
import script from "./ReasonAddNew.vue?vue&type=script&lang=js&"
export * from "./ReasonAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports